<template>
  <div class="rs">
    <div class="rs__box">
      <img v-if="imageSrcSig" :src="imageSrcSig" alt="Reviewer signature" />
      <span v-else>No signature uploaded yet</span>
    </div>

    <div class="rs__row">
      <input
        ref="file"
        type="file"
        accept="image/png,image/jpeg,image/webp"
        style="display: none"
        @change="onPick"
      />
      <button
        type="button"
        class="rs__btn"
        :disabled="signatureUploading"
        @click="$refs.file.click()"
      >
        <span v-if="signatureUploading">Uploading...</span>
        <span v-else>{{ imageSrcSig ? "Replace signature" : "Upload signature" }}</span>
      </button>
      <small class="rs__hint">PNG or JPG, up to 2 MB</small>
    </div>
    <p v-if="signatureError" class="rs__err">{{ signatureError }}</p>
  </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "ReviewSignature",
  mixins: [
    bridge({
      state: ["imageSrcSig", "signatureUploading", "signatureError"],
      methods: ["uploadSignature"],
    }),
  ],
  methods: {
    onPick(event) {
      const file = event.target.files && event.target.files[0];
      this.uploadSignature(file);
      // allow picking the same file again
      event.target.value = "";
    },
  },
};
</script>

<style scoped>
.rs__box {
  min-height: 84px;
  padding: 10px 14px;
  border: 1.5px dashed #c1c4cb;
  border-radius: 12px;
  background: #fbfcff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rs__box img {
  width: auto;
  max-width: 100%;
  height: 72px;
  object-fit: contain;
}
.rs__box span {
  font-size: 13px;
  color: #5f6579;
}
.rs__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-top: 10px;
}
.rs__btn {
  height: 38px;
  padding: 0 18px;
  border: 1.5px solid #f8cfae;
  border-radius: 10px;
  background: #fff;
  color: #e84d00;
  font: inherit;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease;
}
.rs__btn:hover:not(:disabled) {
  background: #fff1e6;
  border-color: #f97316;
}
.rs__btn:disabled {
  opacity: 0.6;
  cursor: wait;
}
.rs__hint {
  font-size: 12px;
  color: #8b90a3;
}
.rs__err {
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #c52222;
}
@media (prefers-reduced-motion: reduce) {
  .rs__btn { transition: none; }
}
</style>